<template>
  <div>
    <router-link v-if="!isMobile && !isSmallScreen" :to="{name: 'mesAccueils'}" class="back-link" title="Retour à mes accueils"><font-awesome-icon :icon="['fas', 'arrow-left']" size="2x" /><span class="sr-only">Retour à mes accueils</span></router-link>
    <EbHeading v-if="!isMobile && !isSmallScreen" level="h1" class="eb-page-heading">Supprimer l’accueil dérogatoire</EbHeading>
    
    <div class="eb-content-default w75">
      <EbBanner :isActive="error" type="error" :timestamp="bannerTimestamp">Une erreur est survenue. Veuillez vérifier votre saisie.</EbBanner>
      
      <form action="#" @submit.prevent="deleteDeclaration()">
        
        <div class="text-center">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="house-user" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-house-user fa-w-18 fa-lg"><path fill="currentColor" d="M570.69,236.27,512,184.44V48a16,16,0,0,0-16-16H432a16,16,0,0,0-16,16V99.67L314.78,10.3C308.5,4.61,296.53,0,288,0s-20.46,4.61-26.74,10.3l-256,226A18.27,18.27,0,0,0,0,248.2a18.64,18.64,0,0,0,4.09,10.71L25.5,282.7a21.14,21.14,0,0,0,12,5.3,21.67,21.67,0,0,0,10.69-4.11l15.9-14V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.88l15.91,14A21.94,21.94,0,0,0,538.63,288a20.89,20.89,0,0,0,11.87-5.31l21.41-23.81A21.64,21.64,0,0,0,576,248.19,21,21,0,0,0,570.69,236.27ZM288,176a64,64,0,1,1-64,64A64,64,0,0,1,288,176ZM400,448H176a16,16,0,0,1-16-16,96,96,0,0,1,96-96h64a96,96,0,0,1,96,96A16,16,0,0,1,400,448Z" class=""></path></svg>
          <EbHeading level="h2" class="eb-box-heading-large">
            <span v-if="declaration.accueilSupplementairePonctuel">
              Accueil supplémentaire
            </span>
            <span v-else>
              Accueil en surnombre
            </span>
          </EbHeading>
          
          <p v-if="declaration.accueilSupplementairePonctuel">
            <span class="text-uppercase">{{ declaration.accueilSupplementairePonctuel.nomEnfant }}</span> {{ declaration.accueilSupplementairePonctuel.prenomEnfant }}, depuis le <b><time :datetime="declaration.dateDebut">{{ getLongDate(declaration.dateDebut) }}</time></b>
          </p>
          <p v-else>
            Date de déclaration : <b><time :datetime="declaration.dateDeclaration">{{ getLongDate(declaration.dateDeclaration) }}</time></b><br>
            Date de début : <b><time :datetime="declaration.dateDebut">{{ getLongDate(declaration.dateDebut) }}</time></b>
          </p>
        </div>
        
        <hr />
        
        <EbTextarea label="Raison de la suppression" width="expand" :rows.number="8" v-model="description" required></EbTextarea>
        
        <div class="eb-button-group">
          <EbButton type="submit">Supprimer la déclaration</EbButton>
          <EbLinkButton :to="{name: 'mesAccueils'}" class="medium text">Annuler la saisie</EbLinkButton>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'clotureAccueilDerogatoire',
  props: {
    idAccueil: null,
  },
  data() {
    return {
      description: null,
      error: false,
      bannerTimestamp: null,
      declaration: {}
    }
  },
  mounted() {
    this.getDeclaration()
  },
  methods: {
    getDeclaration: async function() {    
      await this.$http
      .get(`assmat/accueilsDerogatoires/${this.idAccueil}`)
      .then(resp => {
        this.declaration = resp.data
      })
      .catch(error => {
        this.error = true
        this.bannerTimestamp = this.getTime()
      })
      
    },
    deleteDeclaration: async function() {
      await this.$http
      .delete(`assmat/accueilsDerogatoires/${this.idAccueil}`, {
        data: {
          motif: this.description
        }
      })
      .then(resp => {
        this.$router.push({name: 'mesAccueils', params: {status: 'deleteDerogatoire'}})
      })
      .catch(error => {
        this.error = true
        this.bannerTimestamp = this.getTime()
      })
    }
  },
}
</script>